module.exports = __webpack_public_path__ + "static/media/ic_手术码分类.a78ad656.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_手术码分类.svg
// module id = 340
// module chunks = 0